// extracted by mini-css-extract-plugin
export default {"counts_list":"social-mentions-pieces-SocialCounts__counts_list--22uWm","counts":"social-mentions-pieces-SocialCounts__counts--2Zm5h"};